import moment from 'moment';
import { Validator } from '@vueform/vueform';
import { useRiskStore } from '@/stores/riskData';
import { coverStartBoundsFor, coverStartSpecFromArgs } from './coverStartWindow';

/*
 * Cover start date must sit inside the product's allowed window. The backdating
 * flag lives on an earlier step (its own Vueform), so it's read from the shared
 * risk store. Args come from coverStartRule(): flagPath,backdateDays,forwardDays.
 * Usage: rules: `required|${coverStartRule(WINDOW)}`
 */
export class cover_start_backdate extends (Validator as any) {
    get allowed() {
        const spec = coverStartSpecFromArgs((this as any).attributes);
        return coverStartBoundsFor(useRiskStore().riskData, spec);
    }

    get msg() {
        const { min, max } = this.allowed;
        return `The cover start date must be between ${min.format('DD/MM/YYYY')} and ${max.format('DD/MM/YYYY')}.`;
    }

    check(value: any) {
        if (value == null || value === '') return true;
        const date = moment(value, ['YYYY-MM-DD', moment.ISO_8601, 'DD/MM/YYYY'], true);
        if (!date.isValid()) return true; // format is the date element's own concern
        const { min, max } = this.allowed;
        return date.isSameOrAfter(min, 'day') && date.isSameOrBefore(max, 'day');
    }
}
